import {BaseService} from '../baseService.js';

/* 
 * Handles Drivers
 */
export class DriverService extends BaseService {

	constructor() {	
		super();
	}
	
	async getDrivers(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/drivers' + params);
		return data;
	}	

	async getDriver(driverId) {
		var data = await this.makeGETRequest('/api/resource/drivers/' + driverId);		
		return data;		
	}	
	
	exportDriver(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/drivers/export' + params);		
	};	
	
	async saveDriver(driver, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/drivers/' + driver.driverId, driver);
		} else {
			saved = await this.makePOSTRequest('/api/resource/drivers', driver);
		}
		return saved;
	}	
	
	async getDriverMultiRefs(driverId) {		
		var result = await this.makeGETRequest('/api/resource/drivers/' + driverId + "/references");		
		return result;
	}	
	
	async getDriverMultiRef(driverId, referenceId) {		
		var result = await this.makeGETRequest('/api/resource/drivers/' + driverId + "/references/" + referenceId);		
		return result;
	}	
	
	async saveDriverMultiRef(driverMultiRef, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/drivers/' + driverMultiRef.driverId +  '/references/' + driverMultiRef.multiReferenceId, driverMultiRef);
		} else {
			saved = await this.makePOSTRequest('/api/resource/drivers/' + driverMultiRef.driverId +  '/references', driverMultiRef);
		}
		return saved;
	}	
	
	async deleteDriverMultiRef(driverId, referenceId) {		
		var result = await this.makeDELETERequest('/api/resource/drivers/' + driverId + "/references/" + referenceId);		
		return result;
	}
	
	async activateDriver(driverId) {	
		var result = await this.makePUTRequest('/api/resource/drivers/' + driverId + '/activate');
		return result;
	}	

	async inactivateDriver(driverId) {	
		var result = await this.makePUTRequest('/api/resource/drivers/' + driverId + '/inactivate');
		return result;
	}	
	
};

